$(document).on('click', '[data-toggle=class]', function () {
	var cssClass, elem, target;
	elem = $(this);
	target = elem.attr('data-target');
	cssClass = elem.attr('data-class');
	return $(target).toggleClass(cssClass);
});
